import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import LoginForm from '../components/auth/LoginForm';
import BackLink from '../components/auth/BackLink';
import Brand from '../components/common/Brand';
import useAuth from '../hooks/useAuth';
import './LoginPage.css';

const LoginPage = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (isAuthenticated) {
    const from = location.state?.from?.pathname || '/dashboard';
    return <Navigate to={from} replace />;
  }

  return (
    <div className="auth-page">
      <BackLink />
      <div className="auth-page__container">
        <div className="auth-page__brand">
          <h1><Link to="/" className="auth-page__home"><Brand /></Link></h1>
          <p>Welcome back. Better rental decisions start here.</p>
        </div>
        
        {new URLSearchParams(location.search).get('expired') === 'link' && (
          <div className="auth-message">
            Your session ended. Open the link in your email again to continue where you stopped.
          </div>
        )}

        {location.state?.message && (
          <div className="auth-message success">{location.state.message}</div>
        )}

        <div className="auth-page__card card">
          <div className="card-body">
            <h2 className="auth-page__title">Sign In</h2>
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
